'use strict';

import angular from 'angular';

export default angular.module('vm-services', []);